import { AxiosError, AxiosResponse } from 'axios';
import { createWorkbook } from 'common/api/payroll.api';
import { PayrollInstanceApiRequest } from 'common/types';
import { useMutation } from 'react-query';

export const useCreateWorkbookMutation = () =>
  useMutation<AxiosResponse<any>, AxiosError, PayrollInstanceApiRequest>(
    (workbook: PayrollInstanceApiRequest) => createWorkbook(workbook),
  );
